import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfFlorida = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Florida"
      universityShortName="UF"
      slug="university-of-florida"
      seoTitle="UF Study Rooms | University of Florida Library Study Spaces"
      seoDescription="Find study rooms at UF including Library West group rooms. Learn about floor designations, booking policies, and discover CSW as an online alternative."
      seoKeywords="UF study rooms, University of Florida library, Library West study rooms, Gainesville study spaces, Gator study rooms"
      canonicalUrl="/study-room/university-of-florida/"
      heroDescription="Explore UF's multi-floor library system with designated quiet zones and group study spaces."
      libraryWebsiteUrl="https://uflib.ufl.edu"
      libraryWebsiteName="UF Libraries"
      studySpaces={[
        {
          name: "Library West - Group Rooms",
          features: "18 rooms (6 with monitors), 2-hour blocks, book 10 days ahead. Min 2 people.",
          feedback: "High demand, rooms fill quickly. Some rooms have beeping noise issues."
        },
        {
          name: "Library West - 4th Floor",
          features: "Designated quiet area for focused individual study.",
          feedback: "Enforced quiet zone. Good for concentration."
        },
        {
          name: "Library West - 6th Floor",
          features: "Restricted to graduate students only.",
          feedback: "Excellent for grad students seeking premium quiet space."
        },
        {
          name: "Smathers Library",
          features: "Silent corners, historic atmosphere, individual study spots.",
          feedback: "Beautiful setting for focused work. Less crowded than Library West."
        }
      ]}
      guideContent={
        <>
          <p>
            UF Libraries feature numerous group rooms; Library West alone has 18 group study rooms (six with monitors) 
            available to groups of at least two. Reservations are made in two-hour blocks up to ten days in advance.
          </p>
          <p className="mt-4">
            The lower floors permit quiet conversation, while the fourth floor is a designated quiet area and the 
            sixth floor is restricted to graduate students.
          </p>
          <p className="mt-4">
            For group work, book the Library West rooms early; be sure to pick one with a monitor if you need to project. 
            Individual study is best on the sixth-floor graduate lounge or the silent corners of Smathers Library. 
            Consider using portable whiteboards available at the circulation desk for brainstorming.
          </p>
        </>
      }
      summaryTips={[
        "Book Library West rooms up to 10 days in advance",
        "4th floor is designated quiet, 6th floor is grad-only",
        "6 rooms have monitors for presentations",
        "Portable whiteboards available at circulation desk",
        "Smathers Library offers quieter historic study spaces"
      ]}
    />
  );
};

export default UniversityOfFlorida;
